<script>
import LoadingPage from '@/components/LoadingPage';
import { PAGE_TITLE } from '@/globals';

export default {
    name: 'Logout',
    components: { LoadingPage },
    extends: LoadingPage,
    auth: false,
    async mounted() {
        await this.$store.dispatch('logoutUser');
        // IMPORTANT clear all intervals
        this.$store.commit('clearAppTicker');
        // keep and forward destination "fullPath" to redirect the user to the requested destination
        // after a successful login
        // by default, push to login page
        let pushPath = '/login';
        if (this.$route.query.destination) {
            pushPath = `/login?destination=${encodeURIComponent(this.$route.query.destination)}`;
        }

        await this.$router.push(pushPath);
    },
    head() {
        return {
            title: `${PAGE_TITLE} - Logout`,
        };
    },
};
</script>
